import { Component } from '@angular/core';
import { ResourceService } from 'sce-core';
import { SimpleEntityDataService } from './../../../shared/services/searchable-entity/simple-entity/simple-entity-data.service';
import { ViewMyPrintJobsButtonService } from './services/view-my-print-jobs-button.service';
import { ViewMyPrintJobsActionService } from './services/view-my-print-jobs-action.service';
import { SimpleEntityBackendService } from '../../../shared/services/searchable-entity/simple-entity/simple-entity-backend.service';
import { SimpleEntityDataEditorService } from '../../../shared/services/searchable-entity/simple-entity/simple-entity-data-editor.service';
import { SearchableEntityServiceFactory } from '../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { SearchableEntityConfig } from '../../../shared/models/searchable-entity-config';

@Component({
  selector: 'lfwms-view-my-print-jobs',
  templateUrl: './view-my-print-jobs-home.component.html',
  styleUrls: ['./view-my-print-jobs-home.component.css'],
  providers: [SimpleEntityDataService,
    ViewMyPrintJobsButtonService,
    ViewMyPrintJobsActionService,
    SimpleEntityBackendService,
    SimpleEntityDataEditorService]
})
export class ViewMyPrintJobsHomeComponent {

  public serviceFactory: SearchableEntityServiceFactory;

  constructor(dataService: SimpleEntityDataService,
      buttonService: ViewMyPrintJobsButtonService,
      actionService: ViewMyPrintJobsActionService,
      backendService: SimpleEntityBackendService,
      dataEditor: SimpleEntityDataEditorService,
      private resourceService: ResourceService) {
    this.serviceFactory = new SearchableEntityServiceFactory(dataService,
      actionService, backendService, dataEditor, buttonService);
    dataService.initializeEntityConfiguration(this.createEntityConfig());
    dataService.initializeSearchContext();
  }

  protected createEntityConfig(): SearchableEntityConfig {
    const entityConfig: SearchableEntityConfig = new SearchableEntityConfig('View Print Jobs');
    entityConfig.setPageTitle(this.resourceService.get('lbl_print_jobs'));
    entityConfig.setItemLabel(this.resourceService.get('lbl_print_jobs'));
    entityConfig.setBreadCrumbPrefix('View Print Jobs');
    entityConfig.initializePrimarySearchForTableId('printmyjobtd', 'job_id');
    entityConfig.setSearchPageRoute('/home/reports/viewPrintJobs/');
    entityConfig.setUseAdvancedTable(true);
    entityConfig.getPrimarySearchParams().paginateLocally = false;
    entityConfig.getPrimarySearchParams().isFullFetch = true;
    return entityConfig;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/view-my-print-jobs/view-my-print-jobs-home.component.ts